import { render, staticRenderFns } from "./AddForkTruckAuditPage.vue?vue&type=template&id=4d8cebd2&scoped=true"
import script from "./AddForkTruckAuditPage.vue?vue&type=script&lang=js"
export * from "./AddForkTruckAuditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8cebd2",
  null
  
)

export default component.exports